import Tabs from './Tabs';
import {GlideGenericHelper} from '../utils/GlideManager';

export default class TabbedGalleries {
  get GLIDE_SETUP(){
    return {
        type: 'carousel',
        bound: true,
        dragThreshold: 100,
        autoplay:2000,
        breakpoints: {
            767: {
                perView: 1,
                peek: {
                    before: 0,
                    after: 40
                }
            }
        }
    };
  }
  constructor(targetContainer){
    this.container = targetContainer;
    this.galleries = this.container.querySelectorAll('[data-tab-gallery]');
    if(this.galleries){
      this.init();
    }

  }

  init(){
    this.galleries.forEach( galleryEl =>{

        console.log(`
          has slides: ${this.hasSlides(galleryEl)}
          has single slide: ${this.hasSingleSlide(galleryEl)}
        `)

        if(this.hasSlides(galleryEl)){
            const glideSettings = this.GLIDE_SETUP;
            if (this.hasSingleSlide(galleryEl)) {
              glideSettings.type = 'slider';
              glideSettings.autoplay = false;
              glideSettings.breakpoints = {
                767: {
                    perView: 1,
                    peek: {
                        before: 0,
                        after: 0,
                    }
                }
              }
              console.log(">>> glide settings", glideSettings)
              this.hideGalleryArrows(galleryEl, true);
            } else {
              this.hideGalleryArrows(galleryEl, false);
            }
            GlideGenericHelper(galleryEl, glideSettings);
        } else {
          this.hideGalleryArrows(galleryEl, true);
        }
    });
    if(this.galleries.length>1){
        this.tabsInit();
    }
  }

  hasSlides(gallery){
      let slides = gallery.querySelectorAll('[data-glide-slide]');
      return slides.length > 0;
  }

  hasSingleSlide(gallery) {
      let slides = gallery.querySelectorAll('[data-glide-slide]');
      return slides.length === 1;
  }

  hideGalleryArrows(gallery, shouldHide){
      let arrows = gallery.querySelector('[data-gallery-arrows]');
      arrows.classList.toggle('hidden', shouldHide);
  }

  tabsInit(){
    let comp = new Tabs ({
      wrapperId : 'c-tabbedgalleries_tabs',
    });
  }

}
